import type { ComponentProps } from "react";

import { FieldAutocomplete } from "./FieldAutocomplete";

type Props = Omit<ComponentProps<typeof FieldAutocomplete>, "options"> & {
  languages: Array<{
    code: string;
    title: string;
    disabled?: boolean;
  }>;
};

export const FieldLanguageSelect = ({ languages, ...props }: Props) => {
  return (
    <FieldAutocomplete
      {...props}
      options={languages.map(({ code, title, disabled }) => ({ label: `${title} - ${code}`, value: code, disabled }))}
      freeSolo={false}
      disableClearable
      data-test="language-select"
    />
  );
};
